import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@dealer-center/core-components";
import { useEffect, useState } from "react";

interface versionJSON {
  buildDate: string;
}
export interface VersionJsonAccordionItemProps {
  rootPath: string;
}
export function VersionJsonAccordionItem({
  rootPath
}: VersionJsonAccordionItemProps) {
  const [versionJSON, setVersionJSON] = useState({} as versionJSON);
  const [versionJSONFallback, setVersionJSONFallback] = useState(false);
  useEffect(() => {
    fetch(`/${rootPath}/version.json`)
      .then(res => res.json())
      .then(data => {
        setVersionJSON(data);
        setVersionJSONFallback(false);
      })
      .catch(err => {
        fetch(`/${rootPath}/versionExample.json`)
          .then(res => res.json())
          .then(data => {
            setVersionJSON(data);
            setVersionJSONFallback(true);
          });
      });
  }, []);
  return (
    <Accordion defaultExpanded>
      <AccordionSummary>Version JSON</AccordionSummary>
      <AccordionDetails>
        <p>
          using{" "}
          {versionJSONFallback ? (
            <a href={`/${rootPath}/versionExample.json`}>versionExample.json</a>
          ) : (
            <a href={`/${rootPath}/version.json`}>version.json</a>
          )}
        </p>
        <pre>{JSON.stringify(versionJSON, null, 2)}</pre>
        <p>
          buildDate: {new Date(parseInt(versionJSON.buildDate, 10)).toString()}
        </p>
      </AccordionDetails>
    </Accordion>
  );
}
